import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { ApiService } from "src/app/providers/api.service";
import { Observable, Subscription } from "rxjs";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { CdkOverlayOrigin } from "@angular/cdk/overlay";
import { SlotTimingsComponent } from "src/app/pages/new-v2-pages/new-v2-component/slot-timings/slot-timings.component";
import { redirectLoggedInTo } from "@angular/fire/auth-guard";
import { CalenderDialogComponent } from "src/app/shared/components/calender-dialog/calender-dialog.component";
import { CreateNewBookingComponent } from "src/app/shared/components/create-new-booking/create-new-booking.component";
import { InvoiceComponent } from "src/app/shared/components/invoice/invoice.component";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
import { AddJoiningInterestTimingsComponent } from "../add-joining-interest-timings/add-joining-interest-timings.component";
import { HttpClient } from "@angular/common/http";
import { debounceTime, filter, switchMap } from "rxjs/operators";
import { AuthService } from "src/app/providers/auth.service";
import { CalenderDialogForBookingComponent } from "src/app/shared/components/calender-dialog-for-booking/calender-dialog-for-booking.component";

@Component({
  selector: "sm-add-joining-interest-from-list",
  templateUrl: "./add-joining-interest-from-list.component.html",
  styleUrls: ["./add-joining-interest-from-list.component.scss"],
})
export class AddJoiningInterestFromListComponent implements OnInit, OnDestroy {
  requestStatus: any = "1";
  public newbookingData: any = {
    price: 0,
  };
  home_status: any = sessionStorage.getItem("home_service_status");
  selectedServiceType: any;
  shop_status: any = sessionStorage.getItem("shop_service_status");
  virtual_status: any = sessionStorage.getItem("virtual_service_status");
  ssa: any;
  hsa: any;
  vsa: any;
  isEntityForeign: string = localStorage.getItem(
    SM_CONSTANTS.IS_ENTITY_FOREIGN
  )!;
  countryInfo: any =
    typeof sessionStorage.getItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
    ) == "string"
      ? JSON.parse(
          sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
          )!
        )
      : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT);

  productsList: any = [];
  repeatArray: any = new Array(0);
  form: UntypedFormGroup;
  tempObj: any;
  selectedDays: any = [];
  private _apiSubscription: Subscription = new Subscription();
  selectedBookingType: number = 1;
  serviceList: any = [];
  taxSlabData: any = [];
  discountInfo: any = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    public _modelRef: MatDialog,
    private loader: LoaderServiceService,
    private activemodal: MatDialogRef<AddJoiningInterestFromListComponent>,
        private authService: AuthService

  ) {
    this.form = this.fb.group({
      items: this.fb.array([]),
    });
  }
    isOwner: boolean = false;
    isEntityIndividual: any;

  ngOnInit(): void {
            this.isEntityIndividual = sessionStorage.getItem("isEntityIndividual");

       this.isOwner = this.authService.isOwner();
 if (this.isOwner) {
      this.ssa = this.hsa = this.vsa = 1;
      if (this.shop_status != 2) {
        this.selectedServiceType = "1";
      } else if (this.home_status != 2) {
        this.selectedServiceType = "0";
      } else if (this.virtual_status != 2) {
        this.selectedServiceType = "2";
      }
    } else {
      this.ssa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_OPERATION_ACCESS
      );
      this.hsa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_OPERATION_ACCESS
      );
      this.vsa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_OPERATION_ACCESS
      );

      if (this.shop_status != 2 && this.ssa == "1") {
        this.selectedServiceType = "1";
      } else if (this.home_status != 2 && this.hsa == "1") {
        this.selectedServiceType = "0";
      } else if (this.virtual_status != 2 && this.vsa == "1") {
        this.selectedServiceType = "2";
      }
    }
    let dateobj = this.getOneHourSlot(new Date());
    this.startTime = dateobj.start;
    this.endTime = dateobj.end;

    let tempobj = {
      startTime: dateobj.start,
      endTime: dateobj.end,
      day: {
        dayName: this.getDayName(new Date().getDay()),
        day: new Date().getDay() + 1,
        timeSlots: [],
        is_selected: 1,
      },
    };

    this.selectedDays = [tempobj];

    let data = this.parentData.data;
    this.discountInfo = this.parentData.data.discountInfo;

    if (this.isEntityForeign == "0") {
      this._apiService.getEntityTaxSlabData(data.entityHash);
    } else if (this.isEntityForeign == "1") {
      this._apiService.getInternationalEntityTaxSlabsData(data.entityHash);
    }

    this._apiService.getServicesTypesList(data.entityHash, "0", "0");
    this._apiService.getEntityProductList(data.entityHash, "1");

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      console.log("inAddBookings2:", resData);
      if (
        resData.responseType === SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT
      ) {
        console.log(resData);

        this.serviceList = [];
        if (resData.result) {
          if (this.selectedServiceType == "1") {
            resData.result.forEach((element: any) => {
              if (element.shopStatus == 1 && element.status == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.selectedServiceType == "0") {
            resData.result.forEach((element: any) => {
              if (element.homeStatus == 1 && element.status == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          } else if (this.selectedServiceType == "2") {
            resData.result.forEach((element: any) => {
              if (element.for_virtual == 1 && element.status == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
        }

        this.loader.showLoader = false;
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_PRODUCT_LIST
      ) {
        console.log(resData);

        this.productsList = [];
        if (resData.result) {
          if (this.selectedServiceType == "1") {
            resData.result.forEach((element: any) => {
              if (element.shop_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.selectedServiceType == "0") {
            resData.result.forEach((element: any) => {
              if (element.home_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          } else if (this.selectedServiceType == "2") {
            resData.result.forEach((element: any) => {
              if (element.virtual_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
        }

        this.loader.showLoader = false;
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resData.result) {
          this.taxSlabData = resData.result.filter(
            (item: any) => item.tax_collection_status == 1
          );
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resData.result) {
          this.taxSlabData = resData.result.filter(
            (item: any) => item.tax_collection_status == 1
          );
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_FOR_NEW_BOOKING
      ) {
        if (resData.result) {
          this.loader.showLoader = false;
          this.activemodal.close({
            selectedBookingType: this.selectedBookingType,
            bookingData: this.tempObj,
          });
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_ENROLL_INTEREST_BY_ENTITY
      ) {
        if (resData.result) {
          this.loader.showLoader = false;
          this.activemodal.close({ msg: "success" });
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_WITH_INVOICE
      ) {
        if (resData.result) {
          this.parentData.ref.closeAll();

          this._modelRef.open(InvoiceComponent, {
            width: "510px",
            data: {
              title: "Invoice",
              ref: this._modelRef,
              data: JSON.parse(resData.result).bookingHashId,
            },
          });
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_CUSTOMER_LIST_FOR_AUTOCOMPLETE
      ) {
        this.autocompleteItems = [];
        if (resData.result) {
          this.autocompleteItems = resData.result;
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
        this.loaderForAutocomplete = false;
      }
    });
  }

  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) =>
      country.dial_code === this.countryInfo.countryCode &&
      country.code === this.countryInfo.code
  );
  searchString: UntypedFormControl = new UntypedFormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  openTimings() {
    // this.loader.showLoader = true
    let dialogref = this._modelRef.open(AddJoiningInterestTimingsComponent, {
      width: "450px",
      data: {
        title: "Select day and time",
        serviceType: this.selectedServiceType,
      },
    });

    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        console.log(res);
        res.forEach((element: any) => {
          this.selectedDays.push(element);
        });
      }
    });
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }
  today = new Date();
  selectedDate: any = null;
  onSelectDate() {
    const dialogRef = this._modelRef.open(CalenderDialogForBookingComponent, {
      width: "350px",
      panelClass: "calender-dialog-container",
      data: {
        selectedDate: this.today,
      },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.selectedBookingType = 5;
        this.selectedDate = data;
        console.log(this.today);

        // this.ngOnInit();
      }
    });
  }

  formChecker() {
    if (this.newbookingData.customerPh) {
      if (
        this.newbookingData.customerPh.length >= 3 &&
        this.newbookingData.customerPh.length <= 17
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
  serviceInfo: any = [];
  productInfo: any = [];
  onPost() {
    this.serviceInfo = [];
    this.productInfo = [];
    this.selectedJobs.forEach((element: any) => {
      this.serviceInfo.push({
        service_type_hash: element.hash_id,
        service_name: element.serviceName,
        service_qty: element.selectedCount,
        service_description: element.description,
        service_img_url: element.imgUrl,
        service_rate:
          this.selectedServiceType == "0"
            ? element.discountStatus == 1
              ? element.homeDiscountedPrice
              : element.home_rate
            : this.selectedServiceType == "1"
            ? element.discountStatus == 1
              ? element.shopDiscountedPrice
              : element.shop_rate
            : element.discountStatus == 1
            ? element.virtual_discounted_amount
            : element.virtual_rate,
        service_time: element.approxTime,
        service_sac_code: element.service_sac_code,
        tax_slab_hash: element.tax_slab_hash,
      });
    });

    this.productInfo = this.selectedProducts.map((item: any) => {
      return {
        product_name: item.product_name,
        product_desc: item.product_desc,
        entity_product_hash: item.hash_id,
        product_img_url: item.thumb_image_url,
        product_price:
          this.selectedServiceType == "0"
            ? item.discount_status == 1
              ? item.home_discounted_price
              : item.home_price
            : this.selectedServiceType == "1"
            ? item.discount_status == 1
              ? item.shop_discounted_price
              : item.shop_price
            : item.discount_status == 1
            ? item.virtual_discounted_price
            : item.virtual_price,
        product_qty: item.selectedCount,
        tax_slab_hash: item.tax_slab_hash,
        hsn_code: item.product_hsn_code,
      };
    });

    // --------------- new data formation --------------------

    let obj = {
      // "hash_id": "21b296bb295a9c1800c8aa373bb6a6601acf5950",
      entity_hash: this.parentData.data.entityHash,
      customer_name: this.newbookingData.customerName
        ? this.newbookingData.customerName
        : "New Customer",
      email: this.newbookingData.email,
      customer_country_code: this.selectedCountryCode.dial_code,
      customer_phone: this.newbookingData.customerPh
        ? this.newbookingData.customerPh
        : "0000000000",
      customer_notes: this.newbookingData.note,
      services: this.serviceInfo,
      products: this.productInfo,
      timings: this.selectedDays.map((item: any) => {
        return {
          weekday: item.day.day,
          start_time: item.startTime,
          end_time: item.endTime,
        };
      }),
      custom_items: this.form.get("items")!.value.map((item: any) => {
        return {
          item_name: item.name.item_name ? item.name.item_name : item.name,
          item_desc: item.name.item_desc ?? "",
          item_inventory_hash: item.name.hash_id ?? "",
          item_img_url: item.name.image_thumb_url ?? "",
          item_qty: item.count,
          item_price: +item.price,
          tax_slab_hash: item.tax_slab == "default" ? null : item.tax_slab,
        };
      }),
      interest_type: this.selectedServiceType,
      request_status: this.requestStatus,
      creation_date: this.formatDateforquery(),
    };

    if(this.isEntityIndividual == '0'){
        obj.timings = []
      }

    Object.keys(obj).forEach((key) => {
      if ((obj as any)[key] === null) {
        delete (obj as any)[key];
      }
    });
    obj.services.forEach((element: any) => {
      Object.keys(element).forEach((key) => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
    });
    obj.products.forEach((element: any) => {
      Object.keys(element).forEach((key) => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
    });
    obj.custom_items.forEach((element: any) => {
      Object.keys(element).forEach((key) => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
    });
    console.log(obj);

    this.loader.showLoader = true;
    this._apiService.addEditEnrollInterestByEntity(obj);
  }

  formatDateforquery() {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };

    const formatter = new Intl.DateTimeFormat("en-CA", options);
    const parts = formatter.formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hour = "",
      minute = "",
      second = "";

    parts.forEach((part) => {
      switch (part.type) {
        case "year":
          year = part.value;
          break;
        case "month":
          month = part.value;
          break;
        case "day":
          day = part.value;
          break;
        case "hour":
          hour = part.value;
          break;
        case "minute":
          minute = part.value;
          break;
        case "second":
          second = part.value;
          break;
      }
    });

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }

  allDone() {
    this.serviceInfo = [];

    this.selectedJobs.forEach((element: any) => {
      this.serviceInfo.push({
        service_hash_id: element.hash_id,
        service_name: element.serviceName,
        description: element.description,
        img_url: element.imgUrl,
        approxTime: element.approxTime,
        completed_by_hash_id: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        service_cost:
          this.selectedServiceType == "0"
            ? element.discountStatus == 1
              ? element.homeDiscountedPrice
              : element.home_rate
            : element.discountStatus == 1
            ? element.shopDiscountedPrice
            : element.shop_rate,
        current_status: 3,
      });
    });

    let data = {
      bookingStatusInfo: {
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        bookingType: this.selectedServiceType,
        appointmentHash: "",
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        entityHash: this.parentData.data.entityHash,
        bookingStatus: this.selectedBookingType,
        price: this.newbookingData.price.toString(),
        startTime: this.formatTime(new Date()),
        endTime: this.formatTime(new Date()),
        note: this.newbookingData.note ? this.newbookingData.note : "",
        customerPh: this.newbookingData.customerPh
          ? this.selectedCountryCode.dial_code + this.newbookingData.customerPh
          : this.selectedCountryCode.dial_code + "0000000000",
        customerName: this.newbookingData.customerName
          ? this.newbookingData.customerName
          : "New Customer",
        completedServices: this.serviceInfo,
        bookingDate: this.formatDateString(new Date()),
      },
    };

    console.log(data);
    this.loader.showLoader = true;
    this._apiService.updateBookingStatusWithInvoice(data);
  }

  completedServices: any = [];
  partiallyDone() {
    this.selectedJobs.forEach((element: any) => {
      this.completedServices.push({
        service_hash_id: element.hash_id,
        service_name: element.serviceName,
        description: element.description,
        imgUrl: element.imgUrl,
        approxTime: element.approxTime,
        completed_by_hash_id: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        service_cost:
          this.selectedServiceType == "0"
            ? element.discountStatus == 1
              ? element.homeDiscountedPrice
              : element.home_rate
            : element.discountStatus == 1
            ? element.shopDiscountedPrice
            : element.shop_rate,
        current_status: 3,
      });
    });

    let data = {
      bookingStatusInfo: {
        appointmentHash: "",
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        bookingType: this.selectedServiceType,
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        entityHash: this.parentData.data.entityHash,
        bookingStatus: 9,
        price: this.newbookingData.price,
        startTime: this.formatTime(new Date()),
        endTime: this.addOneHourAndFormat(new Date()),
        note: this.newbookingData.note,
        customerPh: this.newbookingData.customerPh
          ? this.selectedCountryCode.dial_code + this.newbookingData.customerPh
          : this.selectedCountryCode.dial_code + "0000000000",
        customerName: this.newbookingData.customerName
          ? this.newbookingData.customerName
          : "New Customer",
        completedServices: this.completedServices,
        bookingDate: this.formatDateString(new Date()),
      },
    };

    console.log(data);
    this.loader.showLoader = true;
    this._apiService.updateBookingStatus(data);
  }
  allDoneAndRelease() {
    this.selectedJobs.forEach((element: any) => {
      this.completedServices.push({
        service_hash_id: element.hash_id,
        service_name: element.serviceName,
        description: element.description,
        imgUrl: element.imgUrl,
        approxTime: element.approxTime,
        completed_by_hash_id: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        service_cost:
          this.selectedServiceType == "0"
            ? element.discountStatus == 1
              ? element.homeDiscountedPrice
              : element.home_rate
            : element.discountStatus == 1
            ? element.shopDiscountedPrice
            : element.shop_rate,
        current_status: 3,
      });
    });

    let data = {
      bookingStatusInfo: {
        appointmentHash: "",
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        bookingType: this.selectedServiceType,
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        entityHash: this.parentData.data.entityHash,
        bookingStatus: 4,
        price: this.newbookingData.price,
        startTime: this.formatTime(new Date()),
        endTime: this.addOneHourAndFormat(new Date()),
        note: this.newbookingData.note,
        customerPh: this.newbookingData.customerPh
          ? this.selectedCountryCode.dial_code + this.newbookingData.customerPh
          : this.selectedCountryCode.dial_code + "0000000000",
        customerName: this.newbookingData.customerName
          ? this.newbookingData.customerName
          : "New Customer",
        completedServices: this.completedServices,
        bookingDate: this.formatDateString(new Date()),
      },
    };

    console.log(data);
    this.loader.showLoader = true;
    this._apiService.updateBookingStatus(data);
  }

  changeChip(value: number) {
    this.selectedDate = null;
    this.selectedBookingType = value;
    if (value == 1) {
      this.selectedDate = new Date();
    } else if (value == 4) {
      let tempDate = new Date();
      tempDate.setDate(tempDate.getDate() + 1);
      this.selectedDate = new Date(tempDate);
    }
    // this.loader = true
    // this._apiService.getEntitySlotsInfo(this.entityHashId, this.bookingType, this.selectedValue)
  }
  decreaseServiceCount(item: any, index: any) {
    if (this.selectedJobs[index].selectedCount == 1) {
      const index1 = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );
      // const index1 = this.selectedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

      if (this.selectedServiceType == "0") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.selectedJobs[index].homeDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.selectedJobs[index].home_rate;
        }
      } else if (this.selectedServiceType == "1") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.selectedJobs[index].shopDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.selectedJobs[index].shop_rate;
        }
      } else if (this.selectedServiceType == "2") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.selectedJobs[index].virtual_discounted_amount;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.selectedJobs[index].virtual_rate;
        }
      }

      this.serviceList[index1].toShow = true;
      this.selectedJobs.splice(index, 1);
    } else {
      this.selectedJobs[index].selectedCount--;

      if (this.selectedServiceType == "0") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.selectedJobs[index].homeDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.selectedJobs[index].home_rate;
        }
      } else if (this.selectedServiceType == "1") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.selectedJobs[index].shopDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.selectedJobs[index].shop_rate;
        }
      } else if (this.selectedServiceType == "2") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.selectedJobs[index].virtual_discounted_amount;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.selectedJobs[index].virtual_rate;
        }
      }
    }
  }
  increaseServiceCount(item: any, index: any) {
    this.selectedJobs[index].selectedCount++;

    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.selectedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

    if (this.selectedServiceType == "0") {
      if (this.selectedJobs[index].discountStatus == 1) {
        this.newbookingData.price +=
          this.selectedJobs[index].homeDiscountedPrice;
      } else if (this.selectedJobs[index].discountStatus == 0) {
        this.newbookingData.price += this.selectedJobs[index].home_rate;
      }
    } else if (this.selectedServiceType == "1") {
      if (this.selectedJobs[index].discountStatus == 1) {
        this.newbookingData.price +=
          this.selectedJobs[index].shopDiscountedPrice;
      } else if (this.selectedJobs[index].discountStatus == 0) {
        this.newbookingData.price += this.selectedJobs[index].shop_rate;
      }
    } else if (this.selectedServiceType == "2") {
      if (this.selectedJobs[index].discountStatus == 1) {
        this.newbookingData.price +=
          this.selectedJobs[index].virtual_discounted_amount;
      } else if (this.selectedJobs[index].discountStatus == 0) {
        this.newbookingData.price += this.selectedJobs[index].virtual_rate;
      }
    }
  }

  decreaseProductCount(item: any, index: any) {
    if (this.selectedProducts[index].selectedCount == 1) {
      const index1 = this.productsList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );
      // const index1 = this.selectedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);

      if (this.selectedServiceType == "0") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.selectedProducts[index].home_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.newbookingData.price -= this.selectedProducts[index].home_price;
        }
      } else if (this.selectedServiceType == "1") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.selectedProducts[index].shop_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.newbookingData.price -= this.selectedProducts[index].shop_price;
        }
      } else if (this.selectedServiceType == "2") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.selectedProducts[index].virtual_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.newbookingData.price -=
            this.selectedProducts[index].virtual_price;
        }
      }

      this.productsList[index1].toShow = true;
      this.selectedProducts.splice(index, 1);
    } else {
      this.selectedProducts[index].selectedCount--;

      if (this.selectedServiceType == "0") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.selectedProducts[index].home_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.newbookingData.price -= this.selectedProducts[index].home_price;
        }
      } else if (this.selectedServiceType == "1") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.selectedProducts[index].shop_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.newbookingData.price -= this.selectedProducts[index].shop_price;
        }
      } else if (this.selectedServiceType == "2") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.selectedProducts[index].virtual_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.newbookingData.price -=
            this.selectedProducts[index].virtual_price;
        }
      }
    }
  }
  increaseProductCount(item: any, index: any) {
    this.selectedProducts[index].selectedCount++;

    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.selectedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);

    if (this.selectedServiceType == "0") {
      if (this.selectedProducts[index].discount_status == 1) {
        this.newbookingData.price +=
          this.selectedProducts[index].home_discounted_price;
      } else if (this.selectedProducts[index].discount_status == 0) {
        this.newbookingData.price += this.selectedProducts[index].home_price;
      }
    } else if (this.selectedServiceType == "1") {
      if (this.selectedProducts[index].discount_status == 1) {
        this.newbookingData.price +=
          this.selectedProducts[index].shop_discounted_price;
      } else if (this.selectedProducts[index].discount_status == 0) {
        this.newbookingData.price += this.selectedProducts[index].shop_price;
      }
    } else if (this.selectedServiceType == "2") {
      if (this.selectedProducts[index].discount_status == 1) {
        this.newbookingData.price +=
          this.selectedProducts[index].virtual_discounted_price;
      } else if (this.selectedProducts[index].discount_status == 0) {
        this.newbookingData.price += this.selectedProducts[index].virtual_price;
      }
    }
  }

  selectedJobs: any = [];
  selectServices(item: any) {
    console.log(item);

    const index = this.serviceList.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );
    this.serviceList[index].selectedCount = 1;
    this.selectedJobs.push(this.serviceList[index]);
    if (this.selectedServiceType == "0") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.newbookingData.price +=
          this.serviceList[index].homeDiscountedPrice;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.newbookingData.price += this.serviceList[index].home_rate;
      }
    } else if (this.selectedServiceType == "1") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.newbookingData.price +=
          this.serviceList[index].shopDiscountedPrice;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.newbookingData.price += this.serviceList[index].shop_rate;
      }
    } else if (this.selectedServiceType == "2") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.newbookingData.price +=
          this.serviceList[index].virtual_discounted_amount;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.newbookingData.price += this.serviceList[index].virtual_rate;
      }
    }
    this.serviceList[index].toShow = false;
  }
  selectedProducts: any = [];
  selectProducts(item: any) {
    console.log(item);

    const index = this.productsList.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );
    this.productsList[index].selectedCount = 1;
    this.selectedProducts.push(this.productsList[index]);
    if (this.selectedServiceType == "0") {
      if (
        this.productsList[index].discount_status &&
        this.productsList[index].discount_status == 1
      ) {
        this.newbookingData.price +=
          this.productsList[index].home_discounted_price;
      } else if (
        !this.productsList[index].discount_status ||
        this.productsList[index].discount_status == 0
      ) {
        this.newbookingData.price += this.productsList[index].home_price;
      }
    } else if (this.selectedServiceType == "1") {
      if (
        this.productsList[index].discount_status &&
        this.productsList[index].discount_status == 1
      ) {
        this.newbookingData.price +=
          this.productsList[index].shop_discounted_price;
      } else if (
        !this.productsList[index].discount_status ||
        this.productsList[index].discount_status == 0
      ) {
        this.newbookingData.price += this.productsList[index].shop_price;
      }
    } else if (this.selectedServiceType == "2") {
      if (
        this.productsList[index].discount_status &&
        this.productsList[index].discount_status == 1
      ) {
        this.newbookingData.price +=
          this.productsList[index].virtual_discounted_price;
      } else if (
        !this.productsList[index].discount_status ||
        this.productsList[index].discount_status == 0
      ) {
        this.newbookingData.price += this.productsList[index].virtual_price;
      }
    }
    this.productsList[index].toShow = false;
  }

  removeSelectedJobs(item: any) {
    console.log(item);

    const index = this.serviceList.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );
    const index1 = this.selectedJobs.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );

    if (this.selectedServiceType == "0") {
      if (this.selectedJobs[index1].discountStatus == 1) {
        this.newbookingData.price -=
          this.selectedJobs[index1].homeDiscountedPrice *
          this.selectedJobs[index1].selectedCount;
      } else if (this.selectedJobs[index1].discountStatus == 0) {
        this.newbookingData.price -=
          this.selectedJobs[index1].home_rate *
          this.selectedJobs[index1].selectedCount;
      }
    } else if (this.selectedServiceType == "1") {
      if (this.selectedJobs[index1].discountStatus == 1) {
        this.newbookingData.price -=
          this.selectedJobs[index1].shopDiscountedPrice *
          this.selectedJobs[index1].selectedCount;
      } else if (this.selectedJobs[index1].discountStatus == 0) {
        this.newbookingData.price -=
          this.selectedJobs[index1].shop_rate *
          this.selectedJobs[index1].selectedCount;
      }
    } else if (this.selectedServiceType == "2") {
      if (this.selectedJobs[index1].discountStatus == 1) {
        this.newbookingData.price -=
          this.selectedJobs[index1].virtual_discounted_amount *
          this.selectedJobs[index1].selectedCount;
      } else if (this.selectedJobs[index1].discountStatus == 0) {
        this.newbookingData.price -=
          this.selectedJobs[index1].virtual_rate *
          this.selectedJobs[index1].selectedCount;
      }
    }

    this.serviceList[index].toShow = true;
    this.selectedJobs.splice(index1, 1);
  }
  removeSelectedProducts(item: any) {
    console.log(item);

    const index = this.productsList.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );
    const index1 = this.selectedProducts.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );

    if (this.selectedServiceType == "0") {
      if (this.selectedJobs[index1].discount_status == 1) {
        this.newbookingData.price -=
          this.selectedJobs[index1].home_discounted_price *
          this.selectedJobs[index1].selectedCount;
      } else if (this.selectedJobs[index1].discount_status == 0) {
        this.newbookingData.price -=
          this.selectedJobs[index1].home_price *
          this.selectedJobs[index1].selectedCount;
      }
    } else if (this.selectedServiceType == "1") {
      if (this.selectedJobs[index1].discount_status == 1) {
        this.newbookingData.price -=
          this.selectedJobs[index1].shop_discounted_price *
          this.selectedJobs[index1].selectedCount;
      } else if (this.selectedJobs[index1].discount_status == 0) {
        this.newbookingData.price -=
          this.selectedJobs[index1].shop_price *
          this.selectedJobs[index1].selectedCount;
      }
    } else if (this.selectedServiceType == "2") {
      if (this.selectedJobs[index1].discount_status == 1) {
        this.newbookingData.price -=
          this.selectedJobs[index1].virtual_discounted_price *
          this.selectedJobs[index1].selectedCount;
      } else if (this.selectedJobs[index1].discount_status == 0) {
        this.newbookingData.price -=
          this.selectedJobs[index1].virtual_price *
          this.selectedJobs[index1].selectedCount;
      }
    }

    this.productsList[index].toShow = true;
    this.selectedProducts.splice(index1, 1);
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
    return `${hours}:${minutes}`;
  }

  addOneHourAndFormat(date: Date): string {
    const newDate = new Date(date);
    newDate.setHours(date.getHours() + 1);

    const hours = newDate.getHours().toString().padStart(2, "0");
    const minutes = newDate.getMinutes().toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const seconds = inputDate.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  tConv24(time24: any) {
    let ts: any = time24;
    let H: any = +ts.substr(0, 2);
    let h: any = H % 12 || 12;
    h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " AM" : " PM";
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
  }
  startTime: any = null;
  endTime: any = null;
  onSelectSlot() {
    this.loader.showLoader = true;
    let dialogref = this._modelRef.open(SlotTimingsComponent, {
      data: {
        day: this.selectedDate
          ? new Date(this.selectedDate).getDay() + 1
          : new Date(this.today).getDay() + 1,
        entityHash: "jjjj",
        serviceType: this.selectedServiceType,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this.startTime = res.startTime;
        this.endTime = res.endTime;
      }
    });
  }

  removeSelectedDay(index: any) {
    console.log(index);

    this.selectedDays.splice(index, 1);
  }

  getOneHourSlot(date: Date) {
    // Convert to local time string in 24-hour format
    const localTimeString = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    // Get hours and minutes
    let [hours, minutes] = localTimeString.split(":").map(Number);

    // Adjust hours based on minutes (round down to nearest hour)
    let startHour = hours;

    // Calculate next hour
    let endHour = (startHour + 1) % 24;

    // Format hours to always be 2 digits (e.g., 08:00, 23:00)
    const formatHour = (hour: any) => hour.toString().padStart(2, "0");

    // Return the 1-hour slot in 24-hour format
    return {
      start: `${formatHour(startHour)}:00`,
      end: `${formatHour(endHour)}:00`,
    };
  }
  isCurrentDateInRange(start_date: string, end_date: string): boolean {
    const currentDate = new Date();
    const startDate = new Date(start_date);
    const endDate = new Date(end_date);

    // Normalize the dates by setting the time to 00:00:00
    const normalizeDate = (date: Date): Date => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    const normalizedCurrentDate = normalizeDate(currentDate);
    const normalizedStartDate = normalizeDate(startDate);
    const normalizedEndDate = normalizeDate(endDate);

    // Check if the current date is between start and end date (inclusive)
    return (
      normalizedCurrentDate >= normalizedStartDate &&
      normalizedCurrentDate <= normalizedEndDate
    );
  }

  getDayName(dayNumber: any) {
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    // Ensure the input is a valid day number (0-6)
    if (dayNumber >= 0 && dayNumber <= 6) {
      return daysOfWeek[dayNumber];
    } else {
      return "Invalid day number";
    }
  }
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  changerequestStatus(status: any) {
    this.requestStatus = status;
  }

  // Create a new form group for each item
  itemOptions: string[] = ["Item1", "Item2", "Item3", "Item4"]; // List of options
  filteredOptions: Observable<any[]>[] = [];
  createItem(): UntypedFormGroup {
    const itemGroup = this.fb.group({
      name: ["", Validators.required],
      price: ["", Validators.required],
      count: [1, Validators.required],
      tax_slab: ["default"],
    });

    const filterControl = itemGroup.get("name") as UntypedFormControl;

    // Listen for changes, trigger API call if length > 3
    // const filteredOption = filterControl.valueChanges.pipe(
    //   debounceTime(300), // Add debounce to reduce API calls
    //   filter((value) => value.length > 2), // Only call API if input length > 3
    //   switchMap((value) => this.fetchOptions(value)) // Fetch options from API
    // );

    const priceControl = itemGroup.get("price") as UntypedFormControl;

    // Store the previous value to subtract when the value changes
    let previousPrice = 0;

    priceControl.valueChanges.subscribe((value) => {
      // Convert the input value to a number
      const parsedValue = +value;
      if (!isNaN(parsedValue) && value !== "" && value !== undefined) {
        // Subtract the previous price before adding the new one
        this.newbookingData.price =
          this.newbookingData.price - previousPrice + +value;

        // Update the previous price to the new value for future changes
        previousPrice = +value;
      } else {
      }
    });

    // this.filteredOptions.push(filteredOption);
    // console.log(this.filteredOptions);

    return itemGroup;
  }

  displayItemName(item: any): string {
    return item ? item.item_name : ""; // Return only the item_name for display
  }

  // Call the API to fetch options based on the user's input
  fetchOptions(value: string): Observable<string[]> {
    // Example API call: Replace with your actual API endpoint
    return this.http.get<string[]>(
      `https://user-services.lookzup.com/dev/getInventoryDataByKeyword?entityHashId=${this.parentData.data.entityHash}&searchKey=${value}&pageNo=1&count=25`
    );
  }

  // Filter the autocomplete options based on the user's input
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.itemOptions.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  // Get the form array of items
  get items(): UntypedFormArray {
    return this.form.get("items") as UntypedFormArray;
  }

  // Add new form field
  addFormField(): void {
    this.items.push(this.createItem());
  }

  // Remove a form field by index
  removeFormField(index: number): void {
    this.newbookingData.price -= +this.items.at(index).value.price;

    this.items.removeAt(index);
  }

  // Decrease the count and remove the form if count becomes 0
  decreaseCount(index: number): void {
    const currentItem = this.items.at(index);
    const currentCount = currentItem.get("count")!.value;

    if (currentCount > 1) {
      currentItem.get("count")!.setValue(currentCount - 1);
    } else {
      // this.newbookingData.price -= +currentItem.get('price')!.value
      this.removeFormField(index); // Remove the form when count is 0
    }
  }

  // Increase the count
  increaseCount(index: number): void {
    const currentItem = this.items.at(index);
    currentItem.get("count")!.setValue(currentItem.get("count")!.value + 1);
  }

  get formattedPrice(): string {
    return this.newbookingData.price?.toFixed(2);
  }

  set formattedPrice(value: string) {
    this.newbookingData.price = parseFloat(value);
  }

  // ------------ CUSTOMER NAME AUTOCOMPLETE ---------------
  firstTimeBelow3: boolean = false;
  loaderForAutocomplete: boolean = false;
  debounceTimer: any; // Declare this at the class level
  autocompleteItems: any = [];

  searchCustomerName(event: any) {
    if (event.ctrlKey || event.altKey || event.metaKey) {
      return;
    }
    const ignoredKeys = [
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Shift",
      "Control",
      "Alt",
      "Meta",
      "Tab",
      "Escape",
    ];

    if (ignoredKeys.includes(event.key)) {
      return;
    }

    clearTimeout(this.debounceTimer); // Clear previous timer

    this.debounceTimer = setTimeout(() => {
      const value = this.newbookingData.customerName ?? "";
      console.log(value);

      if (value.length >= 3) {
        console.log("holfirst");
        this.loaderForAutocomplete = true;
        this.firstTimeBelow3 = true;
        this._apiService.getCustomerListForAutoComplete(
          value,
          this.parentData.data.entityHash
        );
      } else {
        if (this.firstTimeBelow3) {
          console.log("holsecond");
          this.autocompleteItems = [];
          this.firstTimeBelow3 = false;
        }
      }
    }, 300); // Delay in ms
  }

  selectSearchResult(customer: any) {
    this.autocompleteItems = [];
    this.newbookingData.customerName = customer.name;
    this.selectedCountryCode = this.countryList.find(
      (country) => country.dial_code === customer.country_code
    );
    this.newbookingData.customerPh = customer.phone;
  }

  changeServiceType(type: string) {
    this.selectedJobs = [];

    this.newbookingData.price = 0;
    this.newbookingData.price = this.form
      .get("items")!
      .value.map((item: any) => +item.price || 0)
      .reduce((acc: number, price: number) => acc + price, 0);
    this.selectedServiceType = type;
    this.loader.showLoader = true;
    this._apiService.getServicesTypesList(this.parentData.data.eph, "0", "0");
    this._apiService.getEntityProductList(this.parentData.data.entityHash, "1");
  }
}
